import { Dispatch } from "redux"

import { CLOSE_MODAL, OPEN_MODAL, SET_INVOICE, CLEAR_INVOICE } from "./invoice-types"

export function changeModalState(isOpen: boolean, type: string) {
  return (dispatch: Dispatch) => {
    if (isOpen) return dispatch({ type: OPEN_MODAL, payload: { type } })

    return dispatch({ type: CLOSE_MODAL })
  }
}

export function setInvoice(params: App.InvoiceParams) {
  return (dispatch: Dispatch) => {
    dispatch({ type: SET_INVOICE, payload: params })
  }
}

export function clearInvoice() {
  return (dispatch: Dispatch) => {
    dispatch({ type: CLEAR_INVOICE })
  }
}
